import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const aquaSecurity = defineConnector({
  identifier: "aquaSecurity",
  name: "Aqua Security",
  tagLine: "Cloud native security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.aquasec\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.cloudsploit.com/v2/signin",
        jsonBody: {
          email: app.config.apiKey,
          password: app.secret.apiSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Aqua Security console](https://cloud.aquasec.com/) and navigate to **Administration > API Keys** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Aqua API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Aqua API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.aquasec.com/v2/users",
  },
});
